module.exports = __webpack_public_path__ + "static/media/editor-icon-bold-active.a4de3d46.svg";